import { useQuery } from 'react-query';

import { httpService } from '../../services/http.service';
import { BASE_URL, USER } from '../../constants/endpoints';

const { CONTROLLERS: { PLAID }, BASE: USER_BASE } = USER;

const { ROUTES: { GENERATE: { VERSION, BASE: GENERATE_BASE } } } = PLAID;

export const useGenerateLinkToken = (customerId: string, institutionId: string = '') => useQuery(
  ['generateLinkToken', customerId],
  async () => {
    if (!customerId) {
      return null;
    }
    const { data } = await httpService.post((`${BASE_URL}/${USER_BASE.replace('{version}', VERSION)}/${customerId}/${GENERATE_BASE}`), {
      institutionId,
    });
    return data;
  },
  {
    enabled: false,
  },
);
